const TransportTypeConstant = {
  IMMEDIATE_TRANSPORTER: "IMMEDIATE_TRANSPORTER",
  CUSTOMER_SERVICE_TRANSPORTER: "CUSTOMER_SERVICE_TRANSPORTER",
  WITHOUT_TRANSPORTER: "WITHOUT_TRANSPORTER"
}

export default TransportTypeConstant;
